export default "__VITE_ASSET__DPwHPP15__"